import {
  HttpClient,
  HttpErrorResponse,
  HttpParams,
  type HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { getRestEndpoint } from 'src/app/helpers/api-url';

import { EraStatusUpdate } from '../../interfaces/era/era.interface';

@Injectable({
  providedIn: 'root',
})
export class EraService {
  constructor(private http: HttpClient) {}

  updateStatus(params: EraStatusUpdate): Observable<void> {
    const queryParams = new HttpParams()
      .append('Status', params.Status)
      .append('Filenames', params.Filenames.toString());

    const headers = { X_GROUP_ID: params.X_GROUP_ID };

    return this.http
      .put<undefined>(`${getRestEndpoint()}/eras`, null, {
        params: queryParams,
        headers,
      })
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(() => {
            return error;
          });
        }),
      );
  }

  downloadEra(file: string, xGroupId: string): Observable<HttpResponse<Blob>> {
    const headers = { X_GROUP_ID: xGroupId };
    return this.http
      .get(`${getRestEndpoint()}/eras/download?SubType=ERA&Filename=${file}`, {
        responseType: 'blob',
        observe: 'response',
        headers,
      })
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(() => {
            return error;
          });
        }),
      );
  }
}
